import { useEffect } from 'react';
// import Logo from '../../assets/images/icon-text.png';
interface IProps {}

const DashScreen = (props: IProps) => {
	useEffect(() => {
		console.log('Dashboard');
	}, []);

	return (
		<div className='content-container'>
			{/* <img src={Logo} className='App-logo' alt='SAVI' /> */}
			<p>create art studio admin</p>
		</div>
	);
};

export default DashScreen;
